import {
  DashboardCustomizeOutlined,
  EmailOutlined,
  EventOutlined,
  HomeOutlined,
  PeopleOutlineOutlined,
} from '@mui/icons-material';

import { routeKeys, pageTitles } from '../../../../utils/constants';

const { APP, BOOKING, HOME, MODULES, STUDENTS, SUPPORT } = routeKeys;

export const sideNavConfig = [
  { icon: <HomeOutlined />, path: HOME + APP, title: pageTitles.HOME },
  { icon: <PeopleOutlineOutlined />, path: STUDENTS, title: pageTitles.STUDENTS },
  { icon: <EventOutlined />, path: BOOKING, title: pageTitles.BOOKINGS },
  {
    icon: <DashboardCustomizeOutlined />,
    path: MODULES,
    title: pageTitles.MODULES,
  },
  {
    icon: <EmailOutlined />,
    path: SUPPORT,
    title: pageTitles.SUPPORT,
  },
];
